export default [
  {
    title: '用户管理配置',
    children: [
      { title: '组织树管理', component: 'organTree' },
      { title: '模块配置管理', component: 'moduleConfig' },
      { title: '默认角色管理', component: 'defaultRole' },
      { title: '用户管理版本', component: 'version' }
    ]
  }
]
